import * as THREE from 'three';

// Sets up and places all lights in scene
export default class Light {
	constructor(scene) {
		this.scene = scene;
		this.debug = true;
		this.init();
	}

	init() {
		// Ambient
		this.ambientLight = new THREE.AmbientLight(0x141414);
		this.ambientLight.visible = true;

		// Point light
		this.pointLight = new THREE.PointLight(0xffffff, 0.34, 115);
		this.pointLight.position.set(0, 0, 0);
		this.pointLight.visible = true;

		// Directional light
		this.directionalLight = new THREE.DirectionalLight(0xf0f0f0, 0.4);
		this.directionalLight.position.set(-75, 280, 150);
		this.directionalLight.visible = true;

		// Shadow map
		this.directionalLight.castShadow = true;
		this.directionalLight.shadow.bias = 0;
		this.directionalLight.shadow.camera.near = 250;
		this.directionalLight.shadow.camera.far = 400;
		this.directionalLight.shadow.camera.left = -100;
		this.directionalLight.shadow.camera.right = 100;
		this.directionalLight.shadow.camera.top = 100;
		this.directionalLight.shadow.camera.bottom = -100;
		this.directionalLight.shadow.mapSize.width = 2048;
		this.directionalLight.shadow.mapSize.height = 2048;

		// Shadow camera helper
		if(this.debug) {
			this.directionalLightHelper = new THREE.CameraHelper(this.directionalLight.shadow.camera);
			this.directionalLightHelper.visible = true;
		}
		// Hemisphere light
		this.hemiLight = new THREE.HemisphereLight(0xc8c8c8, 0xffffff, 0.55);
		this.hemiLight.position.set(0, 0, 0);
		this.hemiLight.visible = true;
	}

	place(lightName) {
		switch(lightName) {
		case 'ambient':
			this.scene.add(this.ambientLight);
			break;

		case 'directional':
			this.scene.add(this.directionalLight);
			if(this.debug) {
				this.scene.add(this.directionalLightHelper);
			}
			break;

		case 'point':
			this.scene.add(this.pointLight);
			break;

		case 'hemi':
			this.scene.add(this.hemiLight);
			break;
		}
	}
}
